import Navbar from "./Navbar";
import React, { useState, useEffect } from "react";
import { FaRegCalendarAlt } from "react-icons/fa";
import "./Hero.css";

const Hero = () => {

  const [loading, setLoading] = useState(false);
  const [showBtn, setShowBtn] = useState(false);
  useEffect(() => {

    const handleScroll = () => {

      if (window.innerWidth <= 576) {

        if (window.scrollY > 50) {
          setShowBtn(true);
        } else {
          setShowBtn(false);
        }

      }

    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);

  }, []);


  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    address: "",
    city: "",
    pincode: "",
  });

  // HANDLE CHANGE
  const handleChange = (e) => {

    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });

  };
  const handleSubmit = async (e) => {

    e.preventDefault();

    try {

      setLoading(true);

      const response = await fetch(
        // "http://localhost:5000/book-inspection",
        "https://totalpestcontrol.co.in/book-inspection",
        {
          method: "POST",

          headers: {
            "Content-Type": "application/json",
          },

          body: JSON.stringify(formData),
        }
      );

      const data = await response.json();

      if (data.success) {

        alert(data.message);

        // Clear Form
        setFormData({
          fullName: "",
          email: "",
          phone: "",
          address: "",
          city: "",
          pincode: "",
        });

      } else {
        alert(data.message);
      }

    } catch (error) {

      console.log(error);

      alert("Something went wrong");

    } finally {

      setLoading(false);

    }

  };

  const isFormValid =
    formData.fullName.trim() !== "" &&
    formData.email.trim() !== "" &&
    formData.phone.trim() !== "" &&
    formData.address.trim() !== "" &&
    formData.city.trim() !== "" &&
    formData.pincode.trim() !== "";

  return (
    <div className="hero">
      <Navbar />

      <div className="container hero-container">
        <div className="hero-left">
          <h1 className="hero-title">Safe & Trusted Pest  <br />Control Services</h1>

          <p className="hero-subtitle">
            Protect your home and business with expert pest control solutions.
            Safe, effective and government-approved services.
          </p>

          <div className="hero-buttons">

            <div className="btn-box">
              <p className="btn-title">Company Profile</p>

              <a
                href="/company-profile1.pdf"
                download
                className="btn1"
              >
                Download Now
              </a>
            </div>

            <div className="btn-box">
              <p className="btn-title">Pricing Details</p>

              <a
                href="/pricing-details.pdf"
                download
                className="btn2"
              >
                Download Now
              </a>
            </div>

          </div>
        </div>
      </div>


      <button
        className={`book-btn ${showBtn ? "hide-mobile-book-btn" : ""}`}
        data-bs-toggle="modal"
        data-bs-target="#inspectionModal"
      >
        <FaRegCalendarAlt className="mobile-cal-icon" />
        Book Inspection
      </button>


    </div>

  );

};

export default Hero;

